import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, Box, ButtonGroup } from '@mui/material';
import SectionHeader from 'components/ui/typography/SectionHeader';
import { PropsWithChildren } from 'react';

export interface EnhancedAccordionProps extends PropsWithChildren {
  title?: React.ReactNode;
  subtitle?: string;
  buttons?: React.ReactNode;
  defaultExpanded?: boolean;
  expandIcon?: React.ReactNode;
}

export const EnhancedAccordion = ({
  title,
  subtitle,
  buttons,
  defaultExpanded = false,
  expandIcon = <ExpandMoreIcon />,
  children
}: EnhancedAccordionProps) => {
  const hasHeader = Boolean(title || subtitle);

  return (
    <Accordion
      variant="outlined"
      defaultExpanded={defaultExpanded}
      sx={{
        mb: 3,
        py: 2,
        borderRadius: 2,
        borderColor: 'divider',
        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.04)',
        '&:before': { display: 'none' },
        '&.Mui-expanded': { margin: '0 0 24px 0' },
        overflow: 'hidden'
      }}>
      <AccordionSummary
        expandIcon={expandIcon}
        sx={{
          px: { xs: 2, sm: 3 },
          py: 1,
          '& .MuiAccordionSummary-content': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
            margin: 0,
            '&.Mui-expanded': { margin: 0 }
          }
        }}>
        {/* Intestazione */}
        {hasHeader && <SectionHeader title={title} subtitle={subtitle} />}

        {/* Slot Pulsanti */}
        {buttons && (
          <Box
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            sx={{ ml: 'auto', px: 2 }}>
            <ButtonGroup>{buttons}</ButtonGroup>
          </Box>
        )}
      </AccordionSummary>

      <AccordionDetails
        sx={{
          p: { xs: 2, sm: 3 },
          pt: 0,
          display: 'flex',
          flexDirection: 'column',
          gap: 3
        }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};
